import styled from 'styled-components';

const AuthContactStyles = styled.div`
  text-align: center;
`;

export default AuthContactStyles;
